import type { ErrorFallbackProps } from "@circle-react/components/shared/ErrorBoundary";
import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Button } from "@circleco/compass/components/Button";
import { Icon } from "@circleco/compass/components/Icon";
import { Typography } from "@circleco/compass/components/Typography";
import InnerHTML from "dangerously-set-html-content";

import { t } from "@/i18n-js/instance";

interface ErrorBoundaryFallbackProps extends ErrorFallbackProps {
  className?: string;
  description: string;
  title: string;
  titleVariant?: "heading-sm" | "heading-md";
}

export const ErrorBoundaryFallback = ({
  title,
  description,
  error,
  resetState,
  titleVariant = "heading-md",
  className,
}: ErrorBoundaryFallbackProps) => (
  <div
    className={classNames(
      "flex flex-col items-center gap-3 text-center",
      className,
    )}
  >
    <Icon name="triangle-exclamation-filled" color="danger" size="lg" />
    <Typography variant={titleVariant} color="primary">
      {title}
    </Typography>
    <Typography variant="body-sm" color="secondary">
      <InnerHTML html={description} />
    </Typography>
    <Button variant="primary" onClick={resetState} size="md">
      {t("error_page.try_again")}
    </Button>
    {process.env.NODE_ENV === "development" && error.message && (
      <Typography variant="caption" color="tertiary" component="p">
        {error.message}
      </Typography>
    )}
  </div>
);
